import * as yup from 'yup';

export const LcScaSchema = yup.object().shape({

  // Dados Gerais
  num_registro_sca: yup
    .number()
    .typeError('Campo obrigatório. Mínimo 5 dígitos.')
    .required('Campo obrigatório'),
  sexo_sca: yup.string().nullable(true),
  dn_sca: yup.string().nullable(true),
  convenio_sca: yup.string().nullable(true),

  // Dados da doença e tratamento
  sintomas_data_sca: yup.string().nullable(true),
  sintomas_hora_sca: yup.string().nullable(true),
  outra_instituicao_sca: yup.string().nullable(true),
  entrada_data_sca: yup.string().nullable(true),
  entrada_hora_sca: yup.string().nullable(true),
  ecg_data_sca: yup.string().nullable(true),
  ecg_hora_sca: yup.string().nullable(true),
  classificacao_sca: yup.string().nullable(true),
  fc_sca: yup.string().nullable(true),
  pas_sca: yup.string().nullable(true),
  creatinina_sca: yup.string().nullable(true),
  pcr_sca: yup.string().nullable(true),
  enzimas_sca: yup.string().nullable(true),
  killip_sca: yup.string().nullable(true),
  st_sca: yup.string().nullable(true),
  grace_sca: yup.string().nullable(true),
  tto_sca: yup.string().nullable(true),
  fibrinolitico_data_sca: yup.string().nullable(true),
  fibrinolitico_hora_sca: yup.string().nullable(true),
  angioplastia_data_sca: yup.string().nullable(true),
  angioplastia_hora_sca: yup.string().nullable(true),
  fe_sca: yup.string().nullable(true),
  paliativos_sca: yup.string().nullable(true),

  // Dados da Saída
  covid_sca: yup.string().nullable(true),
  saida_motivo_sca: yup.string().nullable(true),
  saida_data_sca: yup.string().nullable(true),
  saida_hora_sca: yup.string().nullable(true),
  estatina_sca: yup.string().nullable(true),
  bb_sca: yup.string().nullable(true),
  iecabra_sca: yup.string().nullable(true),

  // Seguimento
  reinternacao_sca: yup.string().nullable(true),
  reinternacao_motivo_sca: yup.string().nullable(true),

});
